import { render } from "./NewVirement.vue?vue&type=template&id=1c223df0&ts=true"
import script from "./NewVirement.vue?vue&type=script&lang=ts"
export * from "./NewVirement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__